export default function isPhoneMarketingRules(values, value) {
  if (value && value.length) {
    const phoneRegExp = /^\+?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
    return phoneRegExp.test(value);
  }
  return true;
}
